












import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue {
  @Prop() private value!: boolean;
}
